import React, { FunctionComponent, useCallback } from "react";
import { TreeView } from "@mui/lab";
import { ChevronRight, ExpandMore } from "@mui/icons-material";
import classNames from "classnames";
import _ from "underscore";

import TreeItem from "./tree_item";
import useStateTrackingValue from "../../services/component_helpers/component_effects/use_state_tracking_value";

import type { Breakdown } from "../../services/utilities/breakdown";
import type { Filter } from "../../services/utilities/filter";
import type { StateSetter } from "type_aliases";

const arrowStyle = { color: "var(--light-gray)" };

export type Props = {
  className?: string
  selectedElements?: Filter
  elements: Breakdown<any, any & { id: string | number, subtitle?: string, label?: string, title?: string }>
  onSelect?: (payload: string | number) => void
  onDeselect?: (payload: string | number) => void
  expandedElements?: string[] | number[]
  onToggleExpanded?: StateSetter<string[] | number[]>
}
const initialExpanded = [] as string[];
const selected = [];
export const AvvirTreeView: FunctionComponent<Props> = function AvvirTreeView(props) {
  const { className, selectedElements, expandedElements, elements, onSelect, onDeselect, onToggleExpanded } = props;
  const [expanded, setExpanded] = useStateTrackingValue(expandedElements as unknown as string[], initialExpanded);

  const handleToggle = useCallback((event: React.MouseEvent, nodeIds: string[]) => {
    event.stopPropagation();
    setExpanded(nodeIds);
    if (onToggleExpanded) {
      onToggleExpanded(nodeIds);
    }
  }, [onToggleExpanded, setExpanded]);

  return <TreeView
    className={classNames("AvvirTreeView", className)}
    selected={selected}
    expanded={expanded}
    onNodeToggle={handleToggle}
    onNodeSelect={_.noop}
    multiSelect
    defaultCollapseIcon={<ExpandMore style={arrowStyle}/>}
    defaultExpandIcon={<ChevronRight style={arrowStyle}/>}
  >
    {Object.values(elements.breakdown).map((node) => {
      return <TreeItem key={`AvvirTreeView-${node.id}`} node={node} selectedElements={selectedElements} onSelect={onSelect} onDeselect={onDeselect}/>;
    })}
  </TreeView>;
};

export default React.memo(AvvirTreeView);
